<template>
  <b-table
    class="sticky-table-header"
    :data="products"
    narrowed
    hoverable
    id="products-table"
  >
    <b-table-column field="b" label="Id" v-slot="props">
      {{ props.row.original._id }}
    </b-table-column>

    <b-table-column field="b" label="Imendes Id" v-slot="props">
      {{ props.row.original.imendesId }}
    </b-table-column>

    <b-table-column field="b" label="Código de barras" v-slot="props">
      {{ props.row.b }}
    </b-table-column>

    <b-table-column field="n" label="Nome" v-slot="props">
      {{ props.row.n }}
    </b-table-column>

    <b-table-column field="n" label="Erro" v-slot="props">
      {{ props.row.error }}
    </b-table-column>

    <b-table-column label="Atualizar" v-slot="props">
      <button
        v-if="props.row.original.product.motivodevolucao.toUpperCase() === 'DI'"
        class="button is-success is-small"
        @click="$emit('update', props.row)"
      >
        Atualizar
      </button>
      <button
        v-else
        class="button is-danger is-small"
        @click="$emit('reject', props.row)"
      >
        Rejeitar
      </button>
    </b-table-column>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nada ainda...</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
export default {
  props: ["products"],

  methods: {
    // getProductDetails(product) {
    //   this.$emit("get-product-details", product);
    // },
  }
};
</script>

<style scoped>
#products-table {
  cursor: pointer !important;
}
</style>
